import { render, staticRenderFns } from "./tools.vue?vue&type=template&id=b63cfcd2&scoped=true"
import script from "./tools.vue?vue&type=script&lang=js"
export * from "./tools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63cfcd2",
  null
  
)

export default component.exports